export default __webpack_public_path__ + "static/media/2.ca42ba08.svg";